<template>
  <div class='list-group-item'>
    <div class='infopanel-subhead pb-2'>
      <!-- Last Updated: <strong>{{demographics.LastUpdated | formatDate('MM/DD/YYYY')}}</strong> -->
    </div>
    <ul class="list-unstyled lh-2 pl-1">
      <li v-if='demographics.HouseholdAges'>
        <span class="">Household Ages:</span>
        <strong>{{demographics.HouseholdAges}}</strong>
      </li>
      <li v-if='demographics.CustomerAge'>
        <span class="">Customer Age:</span>
        <strong>{{demographics.CustomerAge}}</strong>
      </li>
      <li v-if='demographics.ChildrenPresent'>
        <span class="">Children Present:</span>
        <strong>{{demographics.ChildrenPresent}}</strong>
      </li>
      <li v-if='demographics.LanguagePreference'>
        <span class="">Language Preference:</span>
        <strong>{{demographics.LanguagePreference}}</strong>
      </li>
      <li v-if='demographics.MaritalStatus'>
        <span class="">Marital Status:</span>
        <strong>{{demographics.MaritalStatus}}</strong>
      </li>
      <li v-if='demographics.HousingStatus'>
        <span class="">Housing Status:</span>
        <strong>{{demographics.HousingStatus}}</strong>
      </li>
    </ul>
    <div v-if='!showDemographicData'>
            There is currently no Demographics data available.
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'customerDemographics',
    props: [
      'demographics'
    ],
    filters: {
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      }
    },
    computed: {
      showDemographicData: function (){
        let demographics = this.demographics
        if(demographics.ChildrenPresent || demographics.LanguagePreference || demographics.MaritalStatus || demographics.HousingStatus || demographics.CustomerAge || demographics.HouseholdAges){
          return true
        }
        else
        {
          return false
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/CustomerProfile/CustomerInfo/InfoPanels/CustomerDemographics.vue